import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Asset from './Asset';

import {
  getSelectedAddonsList,
  getProductDetails,
} from '../../store/selectors/product.selectors';

import {
  filterAddOnImageAssets,
  filterDimensionAssetsByVariantSku,
} from './ProductHelpers';

export class Dimensions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openToggle: props.expanded,
    };
  }

  getDimensionsMeasurements() {
    const {
      productDetails,
      dimensions: cmsDimensions,
    } = this.props;
    return ((
      Array.isArray(cmsDimensions) && cmsDimensions.length
    ) && cmsDimensions)
      || (productDetails && productDetails.dimensions);
  }

  getDimensionImage() {
    const {
      images,
      productDetails,
      selectedAddons,
    } = this.props;
    if (productDetails?.dimensionImages?.length > 1) {
      const {
        dimensionImages,
        skuSplit,
        parentSku,
        skuParse,
      } = productDetails;
      let filteredImages = filterAddOnImageAssets(
        dimensionImages,
        selectedAddons,
        productDetails.productModifiers,
        null,
        parentSku,
        skuParse,
      );

      if (!selectedAddons?.length && (!parentSku.includes('OT') || !parentSku.includes('AO'))) {
        filteredImages = filteredImages.filter((img) => !img.fileName.includes('-OT'));
      }
      if (filteredImages.length > 0 && !selectedAddons?.length) {
        filteredImages = filterDimensionAssetsByVariantSku(filteredImages, skuSplit);
      }
      return filteredImages[0];
    }
    return (
      Array.isArray(images) && images[0])
      || (productDetails?.dimensionImages?.[0]);
  }

  renderMeasurements() {
    const dimensions = this.getDimensionsMeasurements();
    return dimensions && dimensions.map((dimension, i) => (
      <p key={i} className="pdp-dimensions-measurements-item">
        <span className={`pdp-dimensions-measurements-item-title ${dimension.header}`}>
          {dimension.header}
        </span>
        <span className={`pdp-dimensions-measurements-item-copy ${dimension.header}`}>
          {dimension.dimension}
        </span>
      </p>
    ));
  }

  renderImage() {
    const dimensionImage = this.getDimensionImage();
    return (
      <div className="pdp-dimensions-images">
        <div className="pdp-dimensions-images-item">
          {dimensionImage && (
            <Asset
              asset={dimensionImage}
              imageProps={{
                outerWrapperClassName: 'pdp-dimensions-images-item',
              }}
            />
          )}
        </div>
      </div>
    );
  }

  render() {
    const {
      anchor,
      header,
      subHeader,
      toggleAccordion,
    } = this.props;
    const {
      openToggle,
    } = this.state;

    return (
      <section
        id={anchor || undefined}
        className="pdp-btf-section pdp-dimensions"
      >
        <div
          className={classNames('pdp-btf-section-title', { active: openToggle })}
          onClick={toggleAccordion?.bind(this)}
        >
          <h2>{header}</h2>
          <div className="icon-container">
            <i className={classNames('icon', 'icon-nav-arrow', { active: openToggle })} data-testid="icon-nav-arrow"/>
          </div>
        </div>
        <div className={classNames('pdp-btf-section-wrapper', { active: openToggle })}>
          {subHeader && (
            <div className="pdp-dimensions-subhead">
              {subHeader}
            </div>
          )}
          {this.renderImage()}
          <div className="pdp-dimensions-measurements">
            {this.renderMeasurements()}
          </div>
        </div>
      </section>
    );
  }
}

Dimensions.propTypes = {
  anchor: PropTypes.string,
  header: PropTypes.string,
  subHeader: PropTypes.string,
  toggleAccordion: PropTypes.func,
  productDetails: PropTypes.shape({
    dimensionImages: PropTypes.array,
    skuSplit: PropTypes.object,
    parentSku: PropTypes.string,
    skuParse: PropTypes.object,
    sku: PropTypes.string,
  }),
  dimensions: PropTypes.array,
  images: PropTypes.array,
  selectedAddons: PropTypes.array,
};

const mapStateToProps = (state) => ({
  selectedAddons: getSelectedAddonsList(state),
  productDetails: getProductDetails(state),
});

export default connect(mapStateToProps)(Dimensions);
